export const environment = {
    apiDomain: process.env.REACT_APP_API_BASE_URL,
    apiImage: process.env.REACT_APP_S3_BUCKET_URL,
    apiLoginMobile: process.env.REACT_APP_LOGIN_URL_MOBILE,
    jakalaUrl: process.env.REACT_APP_JAKALA_URL,
}